$('body').on('click', '.add-project-asset-trigger', function() {
    openModal('.add-project-asset');
    return false;
});



$("body").on("click", ".open-project-asset-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".project-asset-menu-wrapper");

    $(".project-asset-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".project-asset-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".project-asset-menu-wrapper").attr("data-dropdown"));
    return false;
});


$('body').on('submit', '.add-project-asset form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!modal.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-project-asset', function(data) {
    // console.log(data);
    var element;

    if($('.project-asset[data-project_asset="'+data.project_asset+'"]').length) {
        element = $('.project-asset[data-project_asset="'+data.project_asset+'"]');

        element.attr('data-asset', data.asset);
        element.attr('data-asset_name', data.asset_name);
        element.attr('data-asset_file_name', data.asset_file_name);
        element.attr('data-asset_url', data.asset_url);
        element.attr('data-name', data.name);

        element.find('[data-input="name"]').html(data.name);
        element.find('[data-input="asset_url"]').html(data.asset_url);
        element.find('[data-input="date_added"]').html(data.date_added);
        element.find('.menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'project-asset',
            'data-project_asset': data.project_asset,
            'data-asset': data.asset,
            'data-asset_name': data.asset_name,
            'data-asset_file_name': data.asset_file_name,
            'data-asset_url': data.asset_url,
            'data-name': data.name
        });

        element.append(`<td>
            <p data-input="name">${data.name}</p>
            <p class="small-text" data-input="asset_url">${data.asset_url}</p>
        </td>
        
        <td data-input="date_added">${data.date_added}</td>
        <td class="project-asset-menu-wrapper menu-wrapper" data-dropdown="project-asset-${data.project_asset}">
            <a href="" class="icon-more open-project-asset-menu open-menu"></a>
            <ul class="project-asset-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.project-assets tbody').prepend(element);
    }
});